import { RichText } from '@wordpress/block-editor';
import placeholderImageUrl from '../../../includes/assets/img/bwd-placeholder.jpg';
import icons from '../../options/icons';
const ProfileInfo = ({ attributes, setAttributes }) => {
    const { profileImage, firstName, lastName, designation, socialIcon } = attributes;
    return (
        <div className="cv-header">
             <div className="social-icon" >
                {
                    socialIcon && socialIcon.map((item, index) => {
                        return (
                                <a key={index} href={item.link} target="_blank" rel="noopener noreferrer">
                                    <span className="icon">{icons[item.icon]}</span>
                                </a>
                        );
                    })
                }
            </div>
        <div className="profile-img">
            {profileImage && profileImage.url ? (
                <img src={profileImage.url} alt={profileImage.alt || 'Profile Image'} />
            ) : (
                <img src={placeholderImageUrl} alt="Placeholder" />
            )}
        </div>
        <div className="profile-info">
        <div className="bwdcv-name-wrap">
            <RichText
                tagName="span"
                className="first-name"
                value={ firstName }
                onChange={ ( value ) => setAttributes( { firstName: value } ) }
                placeholder='Enter first name...'
            />
            <RichText
                tagName="span"
                className="last-name"
                value={ lastName }
                onChange={ ( value ) => setAttributes( { lastName: value } ) }
                placeholder='Enter last name...'
            />
            </div>
            <RichText
                className="designation"
                value={ designation }
                onChange={ ( value ) => setAttributes( { designation: value } ) }
                placeholder='Enter designation...'
            />
           
        </div>
        </div>
    )
}

export default ProfileInfo
